import ErrorBoundary from 'dashboard-components/error/ErrorBoundary';
import { capture, SentryEventIds, createFingerprint } from 'dashboard-lib/public/sentry';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const PinnedFilterErrorMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "dashboardHeader.dashboardFilters.allFilters.panel.error"
}) // TODO: update to pinned filter message
;
export const PinnedPropertyErrorBoundary = props => {
  const {
    messageComponent,
    dashboardId
  } = props;
  const errorMessageComponent = messageComponent || PinnedFilterErrorMessage;
  const onError = error => {
    capture(SentryEventIds.PINNED_PROPERTY_ERROR_BOUNDARY, {
      error,
      extra: {
        dashboardId
      },
      fingerprint: createFingerprint(error)
    });
  };
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    ErrorComponent: errorMessageComponent,
    onError: onError,
    name: SentryEventIds.PINNED_PROPERTY_ERROR_BOUNDARY,
    children: props.children
  });
};